import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getWzkCroToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.wzkCRO,
    symbol: 'wzkCRO',
    addressL1: '',
    addressL2: sdks.L2.getContractAddress('wzkCRO'),
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/images/chains/zkevm.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="wzkCRO"
        {...props}
      />
    ),
  };
};
